var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "TcInscriptionConfirm inline-block bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all align-middle max-w-4xl w-full px-5"
    },
    [
      _c("div", { staticClass: "py-10" }, [
        _c("div", { staticClass: "flex flex-col items-center" }, [
          _c(
            "div",
            {
              staticClass:
                "mx-auto flex-shrink-0 flex items-center justify-center rounded-full bg-green-400 text-white"
            },
            [
              _c("TcIcon", {
                staticClass: "h-16 w-16 text-white m-3",
                attrs: { icon: "thumb-up" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "my-5 text-3xl text-center" }, [
            _vm._v("Resumen de la preinscripción")
          ]),
          _vm._v(" "),
          _vm.questions && _vm.questions.length
            ? _c(
                "div",
                { staticClass: "w-7/12 bg-white p-5 mt-3 shadow-lg text-left" },
                [
                  _c("h4", { staticClass: "font-semibold mb-3" }, [
                    _vm._v("Preguntas del evento")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.questions, function(question, index) {
                    return _c("div", { key: index, staticClass: "mb-2" }, [
                      _c("span", { staticClass: "font-medium" }, [
                        _vm._v(_vm._s(question.name) + ":")
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(question.value))])
                    ])
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "w-7/12 bg-gray-100 p-5 mt-3 shadow-lg" }, [
            _c("table", { staticClass: "w-full" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", { staticClass: "w-full" }, [
                _c("tr", { staticClass: "colegiado" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("td", [_vm._v("1")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "price" }, [
                    _vm._v(_vm._s(_vm.event.amount.strToEuro()))
                  ])
                ]),
                _vm._v(" "),
                _vm.companions
                  ? _c("tr", { staticClass: "companions" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.companions.amount))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(
                            _vm.numberToEur(
                              _vm.companions.amount * _vm.companions.unit_price
                            )
                          )
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.guests
                  ? _c("tr", { staticClass: "guests" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.guests.amount))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(
                            _vm.numberToEur(
                              _vm.guests.amount * _vm.guests.unit_price
                            )
                          )
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.children
                  ? _c("tr", { staticClass: "children" }, [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.children.amount))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(
                            _vm.numberToEur(
                              _vm.children.amount * _vm.children.unit_price
                            )
                          )
                        )
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tfoot", [
                _c("tr", { staticClass: "total" }, [
                  _c("td", { attrs: { colspan: "2" } }, [
                    _vm._v("TOTAL A PAGAR:")
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.numberToEur(_vm.total)))])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.total != 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-center items-center gap-3 p-3 bg-red-300"
                  },
                  [
                    _c("TcIcon", {
                      staticClass: "w-28 text-red-600",
                      attrs: { icon: "exclamation" }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checked,
                          expression: "checked"
                        }
                      ],
                      staticClass: "h-20 w-20",
                      attrs: { id: "paymentInfoCheck", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.checked)
                          ? _vm._i(_vm.checked, null) > -1
                          : _vm.checked
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.checked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.checked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.checked = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(5)
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-center items-center gap-3 p-3 bg-red-300"
                  },
                  [
                    _c("TcIcon", {
                      staticClass: "w-10 text-red-600",
                      attrs: { icon: "exclamation" }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checked,
                          expression: "checked"
                        }
                      ],
                      staticClass: "h-8 w-8",
                      attrs: { id: "paymentInfoCheck", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.checked)
                          ? _vm._i(_vm.checked, null) > -1
                          : _vm.checked
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.checked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.checked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.checked = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "paymentInfoCheck" } }, [
                      _vm._v("Acepto las condiciones del evento.")
                    ])
                  ],
                  1
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex w-full justify-center mt-10 gap-3" }, [
            _c(
              "button",
              {
                staticClass: "w-full max-w-sm btn-secondary text-lg p-3",
                on: {
                  click: function($event) {
                    return _vm.$parent.setState(null)
                  }
                }
              },
              [_vm._v("Modificar datos")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "w-full max-w-sm bg-green-400 text-lg p-3",
                attrs: { disabled: !_vm.checked },
                on: { click: _vm.$parent.postEvent }
              },
              [_vm._v("\n          Confirmar preinscripción")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Concepto")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad")]),
        _vm._v(" "),
        _c("th", [_vm._v("Subtotal")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("div", [_vm._v("Colegiado")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("div", [_vm._v("Acompañante")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("div", [_vm._v("Invitado adulto")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("div", [_vm._v("Invitado menor")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "paymentInfoCheck" } }, [
      _vm._v("Acepto que realizaré el "),
      _c("b", [_vm._v("pago en ventanilla")]),
      _vm._v(
        " de este Colegio en el plazo de una hora para validar mi inscripción."
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }